import { CollectibleId_Schema } from "@/services/collectibles/collectiblesSchema";
import { CollectibleParameterElastic_Schema } from "@/services/collectibles/parameters";
import { Theme_Schema } from "@/services/collectibles/themes";
import { CategoryId_Schema } from "@/services/collection/categories";
import { CurrencyId_Schema } from "@/services/currencies/currenciesTypes";
import { z } from "zod";

export const CollectiblePrice = z.object({
  currencyId: CurrencyId_Schema,
  price: z.number(),
  type: z.string(),
  // There is more, but we don't need it for now
});

export const CollectibleElastic_Schema = z
  .object({
    collectibleId: CollectibleId_Schema,
    categoryId: CategoryId_Schema,
    name: z.string(),
    theme: Theme_Schema.nullable(),
    prices: z.record(z.string(), CollectiblePrice).transform((price) => Object.values(price)),
    parameters: z.record(z.string(), CollectibleParameterElastic_Schema).transform((params) => Object.values(params)),
  })
  .transform(({ collectibleId, ...rest }) => ({
    id: collectibleId,
    ...rest,
  }));
